import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-column-select',
  templateUrl: './custom-column.component.html',
})
export class CustomColumnComponent {
  @Input() row: any;
  @Input() items: any[];
  @Output() selection;

  constructor() {}

  getItems() {
    return this.items.map(i => ({ label: i.value, value: i.id }));
  }

  itemClicked(item) {
    if (this.selection instanceof EventEmitter) {
      this.selection.emit(item);
    } else if (this.selection instanceof Function) {
      this.selection(item);
    }
    if (item.onClick) {
      item.onClick();
    }
  }
}
